import styles from './FormFields.module.scss';

import { type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  wrap?: boolean;
  grow?: boolean | number;
  direction?: 'column' | 'row';
}

export function FormFields({
  children,
  direction = 'row',
  grow,
  wrap = true,
}: Props) {
  const className = [
    styles['form-fields'],
    wrap && styles['wrap'],
    typeof grow === 'boolean' && styles['grow'],
    styles['form-fields-direction-' + direction],
  ]
    .filter(Boolean)
    .join(' ');

  const flexGrow = typeof grow === 'number' ? grow : undefined;

  return (
    <div className={className} style={{ flexGrow }}>
      {children}
    </div>
  );
}
